import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EmptyComponent } from '@components/filter-group/empty/empty.component';
import { MultiSelectComponent } from '@components/filter-group/multi-select/multi-select.component';
import { RadioComponent } from '@components/filter-group/radio/radio.component';
import { ExclusiveFilterConfig } from '@models/filters/exclusive-filter-config';
import { FilterStatus } from '@models/filters/filter-status';
import * as FilterType from '@models/filters/filter-type';
import { GenericFilterConfig } from '@models/filters/generic-filter-config';
import { MultiDatepickerComponent } from '../multi-datepicker/multi-datepicker.component';

@Component({
	selector: 'app-exclusive-filters',
	standalone: true,
	imports: [RadioComponent, MultiSelectComponent, EmptyComponent, MultiDatepickerComponent],
	templateUrl: './exclusive-filters.component.html',
	styleUrl: './exclusive-filters.component.css',
})
export class ExclusiveFiltersComponent {
	@Input() genericConfig!: GenericFilterConfig;
	specificConfig!: ExclusiveFilterConfig;
	filterType = FilterType;

	@Output() selectedFilterChanged = new EventEmitter<FilterStatus>();
	@Output() filterSelected = new EventEmitter<string>();

	visibleFilter!: GenericFilterConfig;

	ngOnInit() {
		this.specificConfig = this.genericConfig as ExclusiveFilterConfig;

		// set initially visible filter looking for the default value of the selector
		this.visibleFilter = {
			...this.specificConfig.availableFilters.find(
				(vf) => vf.id == this.specificConfig.selector.defaultValues[0],
			)!,
		};
	}

	/**
	 * Handles change in the selector filter
	 * @param newStatus status of the selector filter
	 */
	onFilterSelection = (newStatus: FilterStatus) => {
		// get id of the filter that we want to make visible
		let selectedFilterId = newStatus.selectedPrimaryValues[0];

		// change visible filter
		let previouslySelectedId = this.visibleFilter.id;
		this.visibleFilter = { ...this.specificConfig.availableFilters.find((af) => af.id == selectedFilterId)! };

		// will lead to remove previous filter values from the parent's filtersStatus dictionary
		this.filterSelected.emit(previouslySelectedId);

		// HANDLE SELECTION OF "NO FILTER" OPTION.
		// Generally, each exclusive filter can specify a filter id that corresponds to the "no filter selected" (here, the value is "nessuno") through the emptyFilterId property.
		// If the selected filter corresponds by id to the "no filter selected" we do not want it to be included in the parent's filtersStatus

		// if emptyFilterId is not specified, emit new values
		if (this.specificConfig.emptyFilterId == undefined) {
			this.selectedFilterChanged.emit({
				filterId: this.visibleFilter.id,
				selectedPrimaryValues: [...this.visibleFilter.defaultValues],
				selectedSecondaryValues: [...this.visibleFilter.defaultValues],
			});
		} else if (this.visibleFilter.id != this.specificConfig.emptyFilterId) {
			// if emptyFilterId is specified but it is not the one that has been clicked, emit new values
			this.selectedFilterChanged.emit({
				filterId: this.visibleFilter.id,
				selectedPrimaryValues: [...this.visibleFilter.defaultValues],
				selectedSecondaryValues: [...this.visibleFilter.defaultValues],
			});
		} else {
			// the emptyFilterId is specified and it has been just clicked
			this.selectedFilterChanged.emit({
				filterId: previouslySelectedId,
				selectedPrimaryValues: [],
				selectedSecondaryValues: [],
			});
		}
	};

	/**
	 * Handles changes im the selected values of the selected filter
	 * @param newStatus status of the changed filter
	 */
	onSelectedFilterChange = (newStatus: FilterStatus) => {
		this.selectedFilterChanged.emit(newStatus);
	};
}
